import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home // Login cuando ya esté implementado
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import( /* webpackChunkName: "login" */ '../components/Login/LoginDefault.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
  }, {
    path: '/agenda',
    name: 'Agenda',
    component: () => import( /* webpackChunkName: "agenda" */ '../components/Agenda/Agenda.vue')
  }, {
    path: '/cita/:id',
    name: 'Cita',
    component: () => import( /* webpackChunkName: "cita" */ '../components/Agenda/Cita.vue'),
    props: true
  }, {
    path: '/ordenes',
    name: 'Ordenes',
    component: () => import( /* webpackChunkName: "ordenes" */ '../components/Ordenes/Lista.vue'),
  }, {
    path: '/ordenes/:id',
    name: 'Orden',
    component: () => import( /* webpackChunkName: "orden" */ '../components/Ordenes/Orden.vue'),
    props: true
  }, {
    path: '/reportes',
    name: 'Reportes',
    component: () => import( /* webpackChunkName: "reportes" */ '../components/Reportes/Reportes.vue')
  }, {
    path: '/inventario',
    name: 'Inventario',
    component: () => import( /* webpackChunkName: "inventario" */ '../components/Inventario/Inventario.vue')
  }, {
    path: '/catalogos/empresa',
    name: 'Empresa',
    component: () => import( /* webpackChunkName: "empresa" */ '../components/Empresa/Empresa.vue')
  }, {
    path: '/catalogos/usuarios',
    name: 'CatalogoUsuarios',
    component: () => import( /* webpackChunkName: "catalogousuarios" */ '../components/Catalogos/Usuarios.vue')
  }, {
    path: '/catalogos/usuarios/:id',
    name: 'CatalogoUsuario',
    component: () => import( /* webpackChunkName: "catalogousuario" */ '../components/Catalogos/Usuario.vue'),
    props: true
  }, {
    path: '/catalogos/brandings',
    name: 'CatalogoBrandings',
    component: () => import( /* webpackChunkName: "catalogobrandings" */ '../components/Catalogos/Brandings.vue')
  }, {
    path: '/catalogos/brandings/:id',
    name: 'CatalogoBranding',
    component: () => import( /* webpackChunkName: "catalogobranding" */ '../components/Catalogos/Branding.vue'),
    props: true
  }, {
    path: '/catalogos/clientes',
    name: 'CatalogoClientes',
    component: () => import( /* webpackChunkName: "catalogoclientes" */ '../components/Catalogos/Clientes.vue')
  }, {
    path: '/catalogos/clientes/:id',
    name: 'CatalogoCliente',
    component: () => import( /* webpackChunkName: "catalogocliente" */ '../components/Catalogos/Cliente.vue'),
    props: true
  }, {
    path: '/catalogos/equipos',
    name: 'CatalogoEquipos',
    component: () => import( /* webpackChunkName: "catalogoequipos" */ '../components/Catalogos/Equipos.vue')
  }, {
    path: '/catalogos/equipos/:id',
    name: 'CatalogoEquipo',
    component: () => import( /* webpackChunkName: "catalogoequipo" */ '../components/Catalogos/Equipo.vue'),
    props: true
  }, {
    path: '/catalogos/equipos/:id/modo/:modo2',
    name: 'CatalogoEquipoConModo',
    component: () => import( /* webpackChunkName: "catalogoequipo" */ '../components/Catalogos/Equipo.vue'),
    props: true
  }, {
    path: '/catalogos/importar',
    name: 'CatalogoImportar',
    component: () => import( /* webpackChunkName: "catalogoimportar" */ '../components/Catalogos/Importar.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router